<template lang="html">
  <Header>
    <Menu mode="horizontal" theme="dark" @on-select="$event[0] != '_' && $router.push({name:$event})" :active-name="$route.name">
      <div>
        <MenuItem name="home">
          <img src="/immagini/logo.png" height="64" style="background: rgba(255,255,255,1); box-shadow: 0 0 20px #666">
        </MenuItem>
        <MenuItem name="home">
          <Icon type="ios-home"></Icon>
          Home
        </MenuItem>
        <MenuItem name="soci.list">
          <Icon type="ios-people"></Icon>
          Soci
        </MenuItem>
        <MenuItem name="contabilita.prima-nota">
          <Icon type="ios-list-outline"></Icon>
          Contabilità
        </MenuItem>
        
        <MenuItem v-if="user.is_admin == 1"
          name="utenti.list">
          <Icon type="ios-list"></Icon>
          Utenti
        </MenuItem>
       <!--  Utenti -->
       <!-- 
       <MenuItem v-if="user.is_admin == 1"
          name="centri.list">
         <Icon type="ios-briefcase"></Icon>
          Centri
        </MenuItem>
        Centri -->
      </div>
      <div style="float: right">
        <MenuItem name="_print" @click.native="printPage">
          <Icon type="printer"></Icon>
          <!-- Stampa -->
        </MenuItem>
        <MenuItem name="settings">
          <Icon type="gear-a"></Icon>
          Impostazioni
        </MenuItem>
        <MenuItem v-if="user.is_admin || user.c_count > 1"
          name="companies" @click.native="$store.company = null">
          <Icon type="navigate"></Icon>
          Cambia Centro
        </MenuItem>
        <MenuItem name="exit" @click.native="$store.logout()">
          <Icon type="log-out"></Icon>
          Esci
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>

<script>
var printer = require('html-screen-capture-js')
export default {
  store: {
    user: 'session.user',
  },
  methods: {
    asdf () {
      alert('asdf')
    },
    printPage () {
      // console.log(printer.capture(
      //   printer.OutputType.STRING,
      //   window.document,
      //   {
      //       'imageFormatForDataUrl': 'image/jpeg',
      //       'imageQualityForDataUrl': 1.0
      //   }
      // ))

      window.print()
    }
  }
}
</script>

<style lang="scss">
// .layout-nav{
//     margin: 0 auto;
//     margin-left: 0;
//     text-align: center;
// }
</style>
